<template>
  <div class="min-h-screen flex flex-col">
    <TheHeader />
    <main class="flex-grow relative" :class="{'pt-0': isHomePage, 'pt-[60px]': !isHomePage}"> <!-- Reduced from 120px to 60px -->
      <router-view/>
    </main>
    <TheFooter />
    <ToastNotification />
    <SandboxBadge />
  </div>
</template>

<script>
import TheHeader from '@/components/layout/TheHeader.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import ToastNotification from '@/components/ui/ToastNotification.vue'
import SandboxBadge from '@/components/ui/SandboxBadge.vue'
import { useCartStore } from '@/stores/cartStore'
import { watch } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    ToastNotification,
    SandboxBadge
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/'
    }
  },
  created() {
    this.$store.dispatch('initializeAuth')
    this.initializeCart()

    // Watches route changes to make sure the cart is reloaded
    const route = useRoute()
    watch(() => route.path, () => {
      console.log('Rota mudou, verificando carrinho')
      this.initializeCart()
    })
  },
  mounted() {
    // Adds a listener for the storage event to refresh the cart when localStorage changes
    window.addEventListener('storage', this.handleStorageChange)

    // Adds a listener for the beforeunload event to make sure the cart is saved before the page closes
    window.addEventListener('beforeunload', this.saveCartBeforeUnload)

    // Adds a listener for the pageshow event to make sure the cart is reloaded when the page is reloaded
    window.addEventListener('pageshow', this.handlePageShow)
  },
  unmounted() {
    // Removes the listeners when the component is unmounted
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('beforeunload', this.saveCartBeforeUnload)
    window.removeEventListener('pageshow', this.handlePageShow)
  },
  methods: {
    initializeCart() {
      const cartStore = useCartStore()
      const user = JSON.parse(localStorage.getItem('user'))

      if (user && user.id) {
        console.log('Inicializando carrinho para o usuário:', user.id)
        cartStore.loadCartFromStorage(user.id)
      } else {
        // Load the guest cart
        const guestCart = localStorage.getItem('cart_guest')
        if (guestCart) {
          console.log('Inicializando carrinho para visitante')
          cartStore.items = JSON.parse(guestCart)
        }
      }
    },

    handleStorageChange(event) {
      // Checks whether the change happened in the cart localStorage
      const cartStore = useCartStore()
      const user = JSON.parse(localStorage.getItem('user'))

      if (user && user.id && event.key === `cart_${user.id}`) {
        console.log('Detectada mudança no localStorage do carrinho do usuário')
        if (event.newValue) {
          cartStore.items = JSON.parse(event.newValue)
        } else {
          cartStore.items = []
        }
      } else if (!user && event.key === 'cart_guest') {
        console.log('Detectada mudança no localStorage do carrinho de visitante')
        if (event.newValue) {
          cartStore.items = JSON.parse(event.newValue)
        } else {
          cartStore.items = []
        }
      }
    },

    saveCartBeforeUnload() {
      const cartStore = useCartStore()
      const user = JSON.parse(localStorage.getItem('user'))

      if (user && user.id) {
        // Only saves when there are items in the cart
        if (cartStore.items && cartStore.items.length > 0) {
          console.log('Salvando carrinho no localStorage antes de fechar a página')
          cartStore.saveCartToStorage(user.id)
        } else {
          // If the cart is empty, remove it from localStorage to keep things consistent
          localStorage.removeItem(`cart_${user.id}`)
        }
      } else {
        // Save the guest cart only when there are items
        if (cartStore.items && cartStore.items.length > 0) {
          localStorage.setItem('cart_guest', JSON.stringify(cartStore.items))
        } else {
          localStorage.removeItem('cart_guest')
        }
      }
    },

    handlePageShow(event) {
      // Checks whether the page was reloaded (F5)
      if (event.persisted) {
        console.log('Página recarregada, reinicializando o carrinho')
        this.initializeCart()
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>


